// Must match CAMPAIGNS["comforter-2026"] in services/api/app/services/giveaways.py,
// which is what actually enforces the entry window.
export const GIVEAWAY = {
    campaign: 'comforter-2026',
    sponsor: 'Round Rock Laundry',
    sponsorAddress: '900 E Palm Valley Blvd, Suite 1006-1007, Round Rock, TX 78664',
    sponsorPhone: '(512) 782-0428',
    startsAt: new Date('2026-10-01T00:00:00-05:00'),
    endsAt: new Date('2026-10-31T23:59:59-05:00'),
    startLabel: 'October 1, 2026 at 12:00 a.m. Central Time',
    endLabel: 'October 31, 2026 at 11:59 p.m. Central Time',
    drawLabel: 'on October 29, 2026',
    prizeShort: 'Free comforter cleaning for 6 months',
    prizeDetail: 'One free comforter cleaning (any size, including down) each month for six consecutive months',
    prizeValue: '$168',
    rulesPath: '/comforter-giveaway-rules',
};

export const MARKETING_CONSENT_TEXT =
    'I agree to receive marketing text messages from Round Rock Laundry at the number above, ' +
    'such as discounts and promotions. Optional; not required to enter. Msg frequency varies. ' +
    'Msg & data rates may apply. Reply STOP to opt out.';

export function giveawayState(now = new Date()) {
    if (now < GIVEAWAY.startsAt) return 'upcoming';
    if (now > GIVEAWAY.endsAt) return 'closed';
    return 'open';
}
